module.exports = __webpack_public_path__ + "img/deleteVideoWhite.444fe740.svg";